import { API } from './api';

interface SubcategoryTabStore {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface SubcategoryTabParams {
  token?: string;
  channelNodes?: string;
  subcategoryTab?: string;
  [key: string]: any;
}

class SubcategoryTabService extends API {
  constructor(store?: SubcategoryTabStore, params?: SubcategoryTabParams) {
    super(store, params);
  }

  override generateUrl(): string {
    const params = this.params as SubcategoryTabParams;
    let tail = params?.channelNodes ? params.channelNodes : '';
    if (params?.channelNodes && !params.channelNodes.includes(',')) {
      tail = (params.subcategoryTab || '') + tail;
    } else if (!params?.channelNodes) {
      tail = params.subcategoryTab || '';
    }
    const lang = (this.store as SubcategoryTabStore)?.lang || 'da';
    return ['channel/', lang, '/', tail].join('');
  }

  async getSubcategoryTab(): Promise<any> {
    return await this.fetchData();
  }
}

export default SubcategoryTabService;
export { SubcategoryTabService };
